import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { FormNumberInput, FormSelectInput } from "form";
import SubTitle from "../Typography/SubTitle";
import NormalText from "../Typography/NormalText";
import { styled } from "@mui/material";

const ContainerStyled = styled("div")({
  width: "100%",
  height: "100%",
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-between",
  overflow: "auto",
  "& .inner": {
    width: "100%",
    "& .analysis-row": {
      display: "flex",
      justifyContent: "space-between",
      padding: "0.25rem 0.75rem",
      alignItems: "baseline",
      backgroundColor: "#f5f5f5",
      "&:nth-child(2n+1)": {
        backgroundColor: "#FFFFFF",
      },
      "&:not(:last-child)": {
        borderBottom: "1px solid #e1e1e1",
      },
      "& .values-col": {
        display: "flex",
        alignItems: "center",
        gap: "0.5rem",
        "& .view-units": {
          width: "100px",
        },
      },
    },
  },
});

const AnalysisFields = ({ analysisFields = {}, isViewOnly }) => {
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const isEn = i18n.language.startsWith("en");

  const analysisValues = useMemo(() => {
    return Object.entries(analysisFields).map(([key, field]) => ({
      ...field,
      quantityUnitOptions: field.quantityUnits.map((unit) => ({
        value: unit,
        label: t(`OperationUnits.${unit}`),
      })),
      key,
    }));
  }, [analysisFields, t]);

  return (
    <ContainerStyled>
      <div className="inner">
        {analysisValues.map((value) => (
          <div key={value.symbol} className="analysis-row">
            <SubTitle>{value.symbol}</SubTitle>
            <NormalText>{isEn ? value.nameEn : value.nameGr}</NormalText>
            <div className="values-col">
              {isViewOnly ? (
                <NormalText>{value.quantity}</NormalText>
              ) : (
                <FormNumberInput
                  name={`diagnoseAction.analysis.${value.key}.quantity`}
                  sx={{ maxWidth: "100px" }}
                />
              )}
              {isViewOnly ? (
                <NormalText className="view-units">
                  {t(`OperationUnits.${value?.quantityUnit}`)}
                </NormalText>
              ) : value.quantityUnits.length <= 1 ? (
                <NormalText className="view-units">
                  {t(`OperationUnits.${value.quantityUnits[0]}`)}
                </NormalText>
              ) : (
                <FormSelectInput
                  name={`diagnoseAction.analysis.${value.key}.quantityUnit`}
                  sx={{ "& .select": { minWidth: "100px", fontSize: "14px" } }}
                  options={value.quantityUnitOptions}
                />
              )}
            </div>
          </div>
        ))}
      </div>
    </ContainerStyled>
  );
};
export default AnalysisFields;
